import React, { useEffect, useState } from "react";

import ComingTrip_icon from "../../../assets/Card/ComingTrip_icon.png";

import {
  Box,
  Button,
  Card,
  Grid,
  Typography,
  CardContent,
  Modal,
} from "@mui/material";

import DashboardLocationCard from "../Card/DashboardLocationCard";
import {
  useGetDevicesLocationsQuery,
  useGetUserTripsQuery,
} from "../../../Api/apiSlice";
import RealTimeMap from "../../DashboardComponents/Card/RealTimeMap";


const maintenanceSchedulingStyles2 = {
  boxContainer: {
    display: "flex",
    alignItems: "center",
    height: "40px",
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%", // Take most of the width for better spacing
    maxWidth: "800px", // Limit the maximum width
    bgcolor: "background.paper",
    borderRadius: "12px",
    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.2)", // Elevate the modal
    p: 4,
    overflow: "hidden", // Prevent overflow
  },
};

function DashboardMainCard() {
  const {
    data: devicesData,
    error: devicesError,
    isLoading: devicesLoading,
    refetch: refetchDevices,
  } = useGetDevicesLocationsQuery();

  const { data, error, isLoading } = useGetUserTripsQuery();
  const [categorizedTrips, setCategorizedTrips] = useState({
    active: [],
    delayed: [],
    upcoming: [],
  });
  const [openModal, setOpenModal] = useState(false); //opening modal
  const [modalTrips, setModalTrips] = useState([]); // Trips
  const [modalTitle, setModalTitle] = useState(""); // Title
  const [sliderIndex, setSliderIndex] = useState(0); // slider
  useEffect(() => {
    if (data) {
      const activeTrips = data.trips.filter((trip) => trip.status === "active");
      const delayedTrips = data.trips.filter(
        (trip) => trip.status === "delayed"
      );
      const upcomingTrips = data.trips.filter(
        (trip) => trip.status === "upcoming"
      );

      setCategorizedTrips({
        active: activeTrips,
        delayed: delayedTrips,
        upcoming: upcomingTrips,
      });
    }
  }, [data]);

  const handleOpenModal = (trips, title) => {
    setModalTrips(trips);
    setModalTitle(title);
    setSliderIndex(0); // Reset slider to first trip
    setOpenModal(true);
  };

  const handleCloseModal = () => setOpenModal(false);
  const renderTripCard = (trip, title, icon, count, trips) => (
    <Card variant="outlined" sx={{ padding: 2, marginBottom: 2 }} key={trip.id}>
      <Box sx={maintenanceSchedulingStyles2.boxContainer}>
        <img src={icon} alt={`${title} Logo`} />
        <Typography variant="body1" sx={{ fontWeight: "bold", ml: 1 }}>
          {title}
        </Typography>
        {count > 1 && (
          <Button
            size="small"
            sx={{ ml: "auto" }}
            onClick={() => handleOpenModal(trips, title)}
          >
            +{count - 1} more
          </Button>
        )}
      </Box>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={1}
      >
        <Typography variant="body2">
          Location: {trip?.startLocation} - {trip?.endLocation}
        </Typography>
        <Typography variant="body2" sx={{ ml: 2 }}>
          Date: {trip?.tripStart || "N/A"}
        </Typography>
      </Box>
    </Card>
  );

  const renderModalContent = () => (
    <Box sx={maintenanceSchedulingStyles2.modalStyle}>
      {/* Modal Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {modalTitle} ({modalTrips.length} trips)
        </Typography>
        <Button
          variant="outlined"
          size="small"
          onClick={handleCloseModal}
          sx={{ textTransform: "none" }}
        >
          Close
        </Button>
      </Box>

      {/* Modal Content - Scrollable Grid */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: 2,
          maxHeight: "60vh",
          overflowY: "auto",
          paddingRight: 1, // for scrollbar
        }}
      >
        {modalTrips.map((trip, index) => (
          <Card
            key={trip.id}
            variant="outlined"
            sx={{
              padding: 2,
              borderRadius: "8px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Trip {index + 1}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              <strong>Location:</strong> {trip.startLocation} -{" "}
              {trip.endLocation}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              <strong>Date:</strong> {trip.tripStart || "N/A"}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              <strong>Assigned To:</strong> {trip.tripAssignedUser.name}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              <strong>Status:</strong> {trip.status}
            </Typography>
          </Card>
        ))}
      </Box>
    </Box>
  );

  // if (isLoading) return <CircularProgress />;
  // if (error)
  //   return <Typography color="error">Error: {error.message}</Typography>;

  return (
    <Card background="#F4F7F7" width={"auto"}>
      <CardContent sx={{ height: "" }}>
        <Grid container spacing={1} alignItems="center">
          {/* Welcome Home & Vehicle Info Section */}
          <Grid item xs={13} md={4}>
            <Box>
              <Box ml={2}>
                <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
                  Welcome Home!
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Grid container spacing={1} item xs={13} md={12}>
          {/* Left Side: Button Group and Map */}
          <Grid item xs={13} md={8}>
            {/* Buttons */}

            <Box sx={{ display: "flex", gap: 2, mt: { lg: 0, xs: 2 } }}></Box>

            {/* Map Section */}
            <Box
              sx={{
                border: "1px solid #ccc",
                borderRadius: "8px",
                marginTop: 1,
                overflow: "hidden",

                height: {
                  xs: "180px", // Height for mobile (extra small)
                  sm: "180px", // Height for small devices (tablets)
                  md: "590px", // Height for medium devices (laptops)
                  lg: "645px", // Height for large devices
                  xl: "615px",
                },
              }}
            >
              {/* <DashboardLocationCard /> */}
              <RealTimeMap/>
            </Box>
          </Grid>

          {/* Right Side: Trip Details and Trip History */}
          <Grid item xs={13} md={4} mt={6}>
            <Box>
              {categorizedTrips.upcoming.length > 0 ? (
                renderTripCard(
                  categorizedTrips.upcoming[0],
                  "Upcoming Trip",
                  ComingTrip_icon,
                  categorizedTrips.upcoming.length,
                  categorizedTrips.upcoming
                )
              ) : (
                <Card sx={{ p: 2 }}>
                  <Typography
                    variant="body1"
                    color="red"
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    No upcoming trips
                  </Typography>
                </Card>
              )}

              <Modal open={openModal} onClose={handleCloseModal}>
                {renderModalContent()}
              </Modal>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default DashboardMainCard;
